import React from 'react';
import WidgetToolbar from './WidgetToolbarComponent.jsx';
//import WidgetStatusBar from './WidgetStatusBarComponent.jsx';
import WidgetLoadingIndicator from './WidgetLoadingIndicatorComponent.jsx';
import Translate from '../core/Translate.js';

class WidgetComponent extends React.Component {
	render() {
		var isLoading = this.props.isLoading;
		//var updatedAt = this.props.updatedAt;
		var isEnded = this.props.isEnded;
		var isDataSourceBroken = this.props.isDataSourceBroken;
		var noData = this.props.noData;
		var isCustomQuery = this.props.isCustomQuery;
		var isStreamQuery = this.props.isStreamQuery;
		var isStarter = this.props.isStarter;
		var isPersistent = this.props.isPersistent;

		var onPauseClick = this.props.onPauseClick;
		var onRefreshClick = this.props.onRefreshClick;
		var onInfoClick = this.props.onInfoClick;
		var onCloseClick = this.props.onCloseClick;
		var onFailClick = this.props.onFailClick;
		var onTitleChanged = this.props.onTitleChanged;
		var onSnapshotClick = this.props.onSnapshotClick;
		var title = this.props.title;
		var brokenMessage = this.props.brokenMessage;
		var hasLatestData = this.props.hasLatestData;

		var elToolbar = (
			<WidgetToolbar
				onPauseClick={onPauseClick}
				onRefreshClick={onRefreshClick}
				onInfoClick={onInfoClick}
				onCloseClick={onCloseClick}
				onFailClick={onFailClick}
				onTitleChanged={onTitleChanged}
				onSnapshotClick={onSnapshotClick}
				isReadOnly={this.props.isReadOnly}
				isLoading={isLoading}
				isDataSourceBroken={isDataSourceBroken}
				isCustomQuery={isCustomQuery}
				isStreamQuery={isStreamQuery}>
				{title}
			</WidgetToolbar>
		);

		var noDataEl = !isStarter ? (
			<div className="error-container">
				<div className="error-well">{Translate.get("$S_msg_NoDataToDisplay")}</div>
			</div>
		) : (
			<div className="error-container">
				<div className="error-well">{Translate.get("$S_msg_NoDataToDisplay")}</div>
			</div>
		)

		var queryFailedEl = (
			<div className="error-container">
				<div className="error-well">{Translate.get("$S_str_QueryFailed")}: {brokenMessage}</div>
			</div>
		);

		var styleAbsolute = {position: 'absolute', top: 0, bottom: 0, left: 0, right: 0};
		// styleAbsolute = {};
		if(!!isCustomQuery || !!isStarter){
			return (
				<div style={styleAbsolute}>
					{elToolbar}
					<div className="widget-container"></div>
					{(noData && !!isStarter && !isPersistent) ? noDataEl : ''}
				</div>
			);
		}
		else if(isEnded) {
			return (
				<div style={styleAbsolute}>
					{elToolbar}
					<div className="widget-container"></div>
					<WidgetLoadingIndicator isEnded={true}>stream ended</WidgetLoadingIndicator>
				</div>
			);
		}
		else if(isLoading) {
			return (
				<div style={styleAbsolute}>
					{elToolbar}
					<div className="widget-container"></div>
					<WidgetLoadingIndicator ellapsed={this.props.ellapsed}></WidgetLoadingIndicator>
				</div>
			);
		}
		else if(isDataSourceBroken) {
			return (
				<div style={styleAbsolute}>
					{elToolbar}
					<div className="widget-container"></div>
					{!hasLatestData ? queryFailedEl : ''}
					<WidgetLoadingIndicator isEnded={true}></WidgetLoadingIndicator>
				</div>
			);
		}
		else {
			return (
				<div style={styleAbsolute}>
					{elToolbar}
					<div className="widget-container"></div>
					{(noData && !isPersistent) ? noDataEl : ''}
				</div>
			);
		}

	}

	shouldComponentUpdate(nextProps, nextState) {
    	// return a boolean value
    	return true;
	}

	componentWillUpdate(nextProps, nextState){
    // perform any preparations for an upcoming update
    	this.props = nextProps;
	}
};

WidgetComponent.defaultProps = {
	isReadOnly: true,
	isLoading: true,
	onPauseClick: () => {},
	onRefreshClick: () => {},
	onFailClick: () => {},
	onInfoClick: () => {},
	onCloseClick: () => {},
	onTitleChanged: () => {}
}

export default WidgetComponent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetComponent.jsx